import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DropDownItem, Dropdown, MenuProps } from '../../../../components/DropDown';
import { TableRowItemData } from '../../../../components/Table';
import { useAppDispatch } from '../../../../hooks/useRedux';
import ModalContainer, { ConfirmationBox } from '../../../../components/Modal';
import dayjs from 'dayjs';
import StatusChip from '../../../../components/StatusChip';
import { useQueryClient } from '@tanstack/react-query';
import plansApi from '../../../../api/plans';
import { LPlan } from '../../../../interfaces/Plan';

export function TableRowItem({ plan, setPlan, navigation }: { plan: LPlan, setPlan?: any, navigation: boolean }) {
  const queryClient = useQueryClient();
  const [statusOptions, setStatusOptions] = useState<MenuProps[]>([]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let items: MenuProps[] = [];
    if (plan.status === 'pending') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={
                <ConfirmationBox
                  loading={loading}
                  text="Are you sure you want to cancel this plan?"
                  onConfirm={(closeModal: () => any) => {
                    plansApi.updatePlanStatus({
                      _id: plan._id,
                      data: {
                        status: 'cancelled'
                      }
                    }).then((res) => {
                      if (res.status === "OK") {
                        queryClient.invalidateQueries({ queryKey: ['plans'] });
                        toast.success('Plan Cancelled');
                        closeModal();
                      } else {
                        toast.success('Something went wrong.');
                      }
                    })
                  }}
                />
              }
            >
              <DropDownItem label="Cancel" onClick={() => { }} />
            </ModalContainer>
          )
        },
        plan.tutorId
          ? {
            key: 2,
            label: (
              <ModalContainer
                ModalComp={
                  <ConfirmationBox
                    loading={loading}
                    text="Are you sure you want to activate this plan?"
                    onConfirm={(closeModal: () => any) => {
                      plansApi.updatePlanStatus({
                        _id: plan._id,
                        data: {
                          status: 'active'
                        }
                      }).then((res) => {
                        if (res.status === "OK") {
                          queryClient.invalidateQueries({ queryKey: ['plans'] });
                          toast.success('Plan Activated');
                          closeModal();
                        } else {
                          toast.success('Something went wrong.');
                        }
                      })
                    }}
                  />
                }
              >
                <DropDownItem label="Active" onClick={() => { }} />
              </ModalContainer>
            )
          }
          : {
            key: 2,
            label: (
              <DropDownItem
                label="Assign Trainer"
                onClick={() => {
                  //TODO: navigate()
                }}
              />
            )
          }
      ];
      setStatusOptions(items);
      return;
    }
    if (plan.status === 'active') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={
                <ConfirmationBox
                  loading={loading}
                  text="Are you sure you want to cancel this plan?"
                  onConfirm={(closeModal: () => any) => {
                    plansApi.updatePlanStatus({
                      _id: plan._id,
                      data: {
                        status: 'cancelled'
                      }
                    }).then((res) => {
                      if (res.status === "OK") {
                        queryClient.invalidateQueries({ queryKey: ['plans'] });
                        toast.success('Plan Cancelled');
                        closeModal();
                      } else {
                        toast.success('Something went wrong.');
                      }
                    })
                  }}
                />
              }
            >
              <DropDownItem label="Cancel" onClick={() => { }} />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }
  }, [plan.status]);

  return (
    <>
      <TableRowItemData
        onClick={() => navigation && navigate(`${plan._id}`)}
        text={`${dayjs(plan.createdAt).format('DD/MM/YYYY')}`}
      />
      <TableRowItemData onClick={() => navigation && navigate(`${plan._id}`)} text={plan._id} />
      <TableRowItemData onClick={() => navigation && navigate(`${plan._id}`)} text={plan.user ? plan.user.name : ''} />
      <TableRowItemData onClick={() => navigation && navigate(`${plan._id}`)} text={plan.user ? plan.user.email : ''} />
      <TableRowItemData onClick={() => navigation && navigate(`${plan._id}`)} text={plan.user ? plan.user.phoneNumber : ''} />
      <TableRowItemData onClick={() => navigation && navigate(`${plan._id}`)} text={plan.totalSessions.toString()} />
      <TableRowItemData
        component={
          <div className="w-full flex relative items-center justify-between">
            <Dropdown menu={statusOptions} placement="bottomLeft">
              <StatusChip
                expand={plan.status === 'active' || plan.status === 'pending'}
                state={
                  plan.status === 'pending'
                    ? 'pending'
                    : plan.status === 'active' && plan.changeRequest?.status === 'pending'
                      ? 'warning'
                      : plan.status === 'active'
                        ? 'success'
                        : plan.status === 'completed'
                          ? 'success'
                          : plan.status === 'cancelled'
                            ? 'error'
                            : 'pending'
                }
              >
                <p className="font-semibold text-[11px] w-24">
                  {plan.status !== "cancelled" && plan.changeRequest?.status === 'pending' ? 'CHANGE REQUEST' : plan.status.toUpperCase()}
                </p>
              </StatusChip>
            </Dropdown>
          </div>
        }
      />
    </>
  );
}

// ${plan.status === 'change-request' && 'bg-[#808286]'}
